<app-navbar></app-navbar>
<div
  class="card"
  style="
    padding: 20px; //background-image: url('assets/img/school/bg.png');
    background-color: #005a63;
    background-size: 100px;
    background-attachment: fixed;
  "
>
  <h2 style=" color: white; text-align:  center; margin-bottom: 10px">Nutrition</h2>
  <div>
    <img
      class="img-fluid"
      style="height: 500px; width: 100%; object-fit: cover; border-radius: 10px"
      src="assets/img/school/nutrition.jpg"
    />
  </div>
  <br />
  <br />
  <div class="container" style="text-align: justify !important">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body text-justify">
            <p>
              There is growing evidence that nutrition and lifestyle
              interventions can be very supportive to individuals with special
              need children like Autism, Down syndrome, Intellectual disability,
              physical disability and someone else. For example, many
              individuals with autism have severely disrupted digestion. So
              restoring balance in the gut is a key focus from a nutritional
              perspective. <br />
              <br />
              All children who attend Proyash-Chattogram will get a nutritional
              counselling session with parents. An expert in nutrition will
              provide the following services. <br />
              <br />
              1. Nutritional assessment. <br />
              2. A personalized diet plan.<br />
              3. Nutritional knowledge sharing training.<br />
              4. Nutritional counselling of parents with children.<br />
              5. Follow-up to assess the improvement.<br />
              <br />
              These services will be provided in a room by face-to-face
              communication for better understanding.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
